import React, { useEffect, useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import LoanService from '../../services/loan.service'
import { useTranslation } from 'react-i18next'
import {
  MENU_SIDEBAR_KEYS,
  DEPOSITS_KEYS,
  LOAN_KEYS,
  DIALOG_KEYS,
  SIDENAV_KEYS,
} from '../../utils/translation-constants'
import Loading from 'custom/assets/loaders/Loading'
import NeoButton from '../../components/NeoButton/NeoButton'
import LayoutWithOutAccountCard from '../../layout/Layout/layout-without-card'
import AddIcon from 'custom/assets/common-icons/Loan_Btn_Icon.svg'
import Pagination from 'react-js-pagination'
import Config from 'custom/config/feature.config.json'
import moment from "moment";

export default function Loans() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loanDetailsLoader, setLoanDetailsLoader] = useState(false)
  const [loanDetails, setLoanDetails] = useState([])
  const [loanStatementDetails, setLoanStatementDetails] = useState([])
  const [loanAccountList, setLoanAccountList] = useState([])
  const [noRecords, setNoRecords] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [expanded, setExpanded] = useState(null)
  const [tabIndex, setTabIndex] = useState(1)
  const [expandedStatement, setExpandedStatement] = useState(null)
  const pageLimit = 5
  const [slicedDetailStatementList, setSlicedDetailStatementList] = useState([])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderList()
      default:
        return renderList()
    }
  }

  useEffect(() => {
    getAccounts()
  }, [])

  const getLoanAccountDetails = useCallback(
    async (loanDetails) => {
      try {
        setLoading(true)
        const reqParams = {
          accountNo: loanDetails.accountNo,
          brnCode: loanDetails.brnCode,
        }
        const response = await LoanService.getAccountDetails(reqParams)
        if (response.status === 200) {
          setLoanDetails(response.data)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [loanAccountList],
  )

  const getLoanAccountStatementDetails = useCallback(
    async (loanDetails) => {
      try {
        setLoading(true)
        const reqParams = {
          accountNo: loanDetails.accountNo,
          brnCode: loanDetails.brnCode,
        }
        const response = await LoanService.getLoanAccountStatement(reqParams)
        if (response.status === 200) {
          setLoanStatementDetails(response.data['loanAccList'])
          sliceDetailedStatement(1, response.data['loanAccList'])
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [loanAccountList],
  )

  function renderLoading() {
    return (
      <div className='d-flex flex-column text-center justify-content-center align-items-center'>
        <div className='my-4'>
          <Loading width='50px' height='50px' />
        </div>
      </div>
    )
  }
  const getAccounts = useCallback(async () => {
    try {
      const response = await LoanService.getLoanAccounts()
      if (response.status === 200) {
        response.data['accountSummaryDetails'].forEach((element) => {
          element.isActive = false
        })
        setLoanAccountList(response.data['accountSummaryDetails'])
        //sliceDetailedStatement(1, response.data['accountSummaryDetails'])
        setStage(1)
        setNoRecords(response.data['accountSummaryDetails'].length > 0 ? false : true)
      }
    } catch (err) {}
  }, [dispatch])

  const sliceDetailedStatement = useCallback(async (currentPageNo, lst) => {
    // useEffect (  () => {
    setCurrentPage(currentPageNo)
    let start = (currentPageNo - 1) * pageLimit
    let end = currentPageNo * pageLimit
    if (lst && lst.length > 0) {
      let x = lst.slice(start, end < lst.length ? end : lst.length)
      setExpandedStatement(null)
      setSlicedDetailStatementList(x)
    } else {
    }
  }, [])

  function renderView() {
    return (
      <>
        {!loading && (
          <div className='row'>
            <div className='col-4'>
              <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REFERENCE_NUMBER)}</label>
              <span>{loanDetails?.userRefNo || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.ACCOUNT_DESCRIPTION)}</label>
              <span>{loanDetails?.accDesc || '-'}</span>
              <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.ACCOUNTNO_1)}</label>
              <span>{loanDetails?.accountNo || '-'}</span>
            </div>
            <div className='col-4'>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.AMOUNT_PAID)}</label>
              <span>{loanDetails?.amountPaid || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.brnCode)}</label>
              <span>{loanDetails?.brnCode || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.currency)}</label>
              <span>{loanDetails?.currency || '-'}</span>
            </div>

            <div className='col-4'>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.CUSTOMER_ID)}</label>
              <span>{loanDetails?.customerId || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.INTEREST_RATE)}</label>
              <span>{loanDetails?.interestRate || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.maturityDate)}</label>
              <span>{moment(loanDetails?.maturityDate).format("YYYY-MM-DD") || '-'}</span>
            </div>

            <div className='col-4'>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.NEXT_DATE)}</label>
              <span>{moment(loanDetails?.nextPaymentDate).format("YYYY-MM-DD") || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.OUTSTANDING_BALANCE)}</label>
              <span>{loanDetails?.outstandingBalance || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.PRINCIPAL_AMOUNT)}</label>
              <span>{loanDetails?.principleAmount || '-'}</span>
            </div>

            <div className='col-4'>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.PROD_CATEGORY)}</label>
              <span>{loanDetails?.prodCategory || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.REPAYMENT_INSTALLMENT)}</label>
              <span>{loanDetails?.rePaymentInstallment || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.REMAINING_NO_PAYMENTS)}</label>
              <span>{loanDetails?.remainingNoRepayment || '-'}</span>
            </div>
            <div className='col-4'>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.REPAYMENT_STATUS)}</label>
              <span>{loanDetails?.repaymentStatus || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.status)}</label>
              <span>{loanDetails?.status || '-'}</span>
              <label>{t(LOAN_KEYS.DETAILS_KEYS.VALUE_DATE)}</label>
              <span>{moment(loanDetails?.valueDate).format("YYYY-MM-DD") || '-'}</span>
            </div>
          </div>
        )}
      </>
    )
  }

  function renderStatement() {
    return (
      <>
        {loanStatementDetails.length === 0 && (
          <div className='no-data-found'>{t(DIALOG_KEYS.NO_STATEMENT)} </div>
        )}
        {slicedDetailStatementList.map((option, index) => (
          <div key={index} className='loan-card' style={{ backgroundColor: '#fff' }}>
            <div
              className='loan-header'
              onClick={async () => {
                if (expandedStatement == index) {
                  setExpandedStatement(null)
                } else {
                  setExpandedStatement(index)
                }
              }}>
              <span>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REF)} : {option.refNo}
              </span>
              {option?.amount}
            </div>

            {expandedStatement === index && (
              <div className='row loan-details'>
                <div className='col-4'>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.ACCOUNTNO_1)}</label>
                  <span>{option?.accNo || '-'}</span>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REFERENCE_NUMBER)}</label>
                  <span>{option?.refNo || '-'}</span>
                </div>
                <div className='col-4'>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.AMOUNT)}</label>
                  <span>{option?.amount || '-'}</span>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.SERIAL)}</label>
                  <span>{option?.slNumber || '-'}</span>
                </div>
                <div className='col-4'>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.TRANS_DATE)}</label>
                  <span>{moment(option?.transactionDate).format("YYYY-MM-DD") || '-'}</span>
                  <label>{t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.NARRATION)}</label>
                  <span>{option?.narration || '-'}</span>
                </div>
              </div>
            )}
          </div>
        ))}
        {loanStatementDetails.length > 0 && loanStatementDetails.length > 5 ? (
          <div className='d-flex justify-content-center mb-5 mt-2'>
            {loading ? null : (
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={5}
                totalItemsCount={loanStatementDetails.length}
                pageRangeDisplayed={5}
                itemClass='page-item'
                linkClass='page-link'
                onChange={(page) => sliceDetailedStatement(page, loanStatementDetails)}
              />
            )}
          </div>
        ) : null}
      </>
    )
  }

  function renderList() {
    return (
      <>
        {noRecords && <div className='no-data-found'>{t(DIALOG_KEYS.NO_LOANS)}</div>}

        {loanAccountList.map((option, index) => (
          <div key={index} className='loan-card'>
            <div
              className='loan-header'
              onClick={async () => {
                if (expanded == index) {
                  setExpanded(null)
                  setExpandedStatement(null)
                } else {
                  setTabIndex(1)
                  setExpanded(index)
                  setExpandedStatement(null)
                  await getLoanAccountDetails(option)
                  await getLoanAccountStatementDetails(option)
                }
              }}>
              <span>{t(LOAN_KEYS.NEW_LOAN_KEYS.LOAN_ACCOUNT_NO1)}</span>
              <span>{option?.accountNo}</span>
            </div>

            {expanded === index && (
              <div className='loan-details'>
                <div className='row tab-navbar'>
                  <div className={tabIndex === 1 ? 'col-4 selected' : 'col-4'}>
                    <span
                      onClick={() => {
                        setTabIndex(1)
                        setExpandedStatement(null)
                      }}>
                      {t(DEPOSITS_KEYS.SELECT_TYPE_KEYS.VIEW)}
                    </span>
                  </div>
                  <div className={tabIndex === 2 ? 'col-4 selected' : 'col-4'}>
                    <span
                      onClick={() => {
                        setTabIndex(2)
                      }}>
                      {t(DEPOSITS_KEYS.SELECT_TYPE_KEYS.STATEMENT)}
                    </span>
                  </div>
                </div>
                {loading && renderLoading()}
                {tabIndex === 1 && !loading && renderView()}
                {tabIndex === 2 && !loading && renderStatement()}
              </div>
            )}
          </div>
        ))}
      </>
    )
  }

  return (
    <>
      <LayoutWithOutAccountCard breadCumKey='LOANS' showEmptySpace={true} keyPath={'LOAN'}>
        <div className='row'>
          <div className='col-4 d-flex'>
            <div className='heading-style'>{t(MENU_SIDEBAR_KEYS.LOANS)}</div>
          </div>
          <div className='col-8 text-right'>
            {Config.LOANS.applyLoan && (
              <button
                onClick={() => history.push('/loans/apply')}
                type='button'
                className='btn detailed-statement-btn'>
                <img width={25} height={25} src={AddIcon} />
                <span className='font-weight-600' style={{ marginLeft: 8 }}>
                  {t(LOAN_KEYS.SELECT_ACCOUNT_KEYS.APPLY_BUTTON)}
                </span>
              </button>
            )}

            {loanAccountList.length > 0 && Config.LOANS.loanPayment && (
              <button
                style={{ marginLeft: 20 }}
                onClick={() =>
                  history.push({
                    pathname: '/loans/repayment',
                    state: { loanAccounts: loanAccountList },
                  })
                }
                type='button'
                className='btn detailed-statement-btn'>
                <img width={25} height={25} src={AddIcon} />
                <span className='font-weight-600' style={{ marginLeft: 8 }}>
                  {t(LOAN_KEYS.NEW_LOAN_KEYS.SUBTITLE_2)}
                </span>
              </button>
            )}
          </div>
        </div>

        {renderSwitch()}
      </LayoutWithOutAccountCard>

      {/* <div className='row my-4'>
        {loanAccountList.length > 0 ? (
          <div className='col-6'>
            <div
              className='bg-bluegray cursor-pointer rounded-1 d-flex justify-content-center align-items-center text-center font-weight-500'
              style={{ padding: 60 }}
              onClick={() =>
                history.push({
                  pathname: '/loans/repayment',
                  state: { loanAccounts: loanAccountList },
                })
              }>
              {'Loan Repayment'}
              <br />
            </div>
          </div>
        ) : null}

        <div className='col-6'>
          <div
            className='bg-bluegray cursor-pointer rounded-1 d-flex justify-content-center align-items-center text-center font-weight-500'
            style={{ padding: 60 }}
            onClick={() => history.push('/loans/apply')}>
            {t(LOAN_KEYS.SELECT_ACCOUNT_KEYS.APPLY_BUTTON)}
            <br />
          </div>
        </div>
      </div> */}
    </>
  )
}
